import { supabase } from "@/integrations/supabase/client";

/**
 * READS of a user profile go through public.profiles_safe. WRITES stay on
 * public.profiles.
 *
 * Why: `authenticated` has no table-level SELECT on profiles — only
 * column-level SELECT on 131 of its 137 columns, six secret-bearing columns
 * being deliberately withheld from the browser. PostgREST turns `.select("*")`
 * into `select=*`, which asks for all 137, so Postgres refuses the whole
 * statement with 403 — even when a user is reading their OWN row. That is why
 * /admin/users showed "Users (0)" and Settings came up blank.
 *
 * profiles_safe is that same table minus the six columns, declared
 * security_invoker so profiles' RLS still decides which rows come back. It
 * widens nothing; it only stops asking for columns the browser may not have.
 *
 * The cast is because the view is not in the generated Database types. Its
 * rows are profiles rows minus six columns no UI reads, so the profiles row
 * type is the honest shape for callers.
 */
export function profilesRead() {
  return supabase.from("profiles_safe" as unknown as "profiles");
}

/** The six columns the browser must never request. Kept here so the reason is findable. */
export const PROFILE_WITHHELD_COLUMNS = [
  "calendly_personal_token",
  "cal_com_api_key",
  "slack_webhook_url",
  "browser_push_subscription",
  "identity_fingerprint",
  "proof_share_token",
] as const;
